 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		47: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		47: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "app." + ({"7":"DeprecatedStyles","13":"EnhancedStyles","14":"app-components-Workflow-WorkflowContainer","15":"app-components-bibs-BibPage-BibPageContainer","16":"app-components-bibs-subpages-AllCommentsPage-AllCommentsPageContainer","17":"app-components-bibs-subpages-AllContentNoticesPage-AllContentNoticesPageContainer","18":"app-components-bibs-subpages-AllListsPage-AllListsPageContainer","19":"app-components-bibs-subpages-AllQuotationsPage-AllQuotationsPageContainer","20":"app-components-bibs-subpages-AllRecommendationsPage-AllRecommendationsPageContainer","21":"app-components-bibs-subpages-AllReviewsPage-AllReviewsPageContainer","22":"app-components-bibs-subpages-AllSummariesPage-AllSummariesPageContainer","23":"app-components-bibs-subpages-AllVideosPage-AllVideosPageContainer","24":"app-components-bibs-subpages-CommentPage-CommentPageContainer","25":"app-components-bibs-subpages-MarcPage-MarcPageContainer","26":"app-components-bibs-subpages-QuotationPage-QuotationPageContainer","27":"app-components-bibs-subpages-SummaryPage-SummaryPageContainer","28":"app-components-bibs-subpages-VideoPage-VideoPageContainer","29":"app-components-borrowing-accountmessages-AccountMessages-AccountMessagesContainer","30":"app-components-borrowing-checkouts-CheckedOut-CheckedOutContainer","31":"app-components-borrowing-checkouts-CheckedOutPrintList-CheckedOutPrintListContainer","32":"app-components-borrowing-fines-Fines-FinesContainer","33":"app-components-borrowing-holds-Holds-HoldsContainer","34":"app-components-borrowing-holds-HoldsPrintList-HoldsPrintListContainer","35":"app-components-borrowing-interlibraryLoans-InterlibraryLoans-InterlibraryLoansContainer","36":"app-components-borrowing-interlibraryLoans-InterlibraryLoansPrintList-InterlibraryLoansPrintListContainer","37":"app-components-borrowing-recentlyreturned-RecentlyReturned-RecentlyReturnedContainer","38":"app-components-borrowing-recentlyreturned-RecentlyReturnedPrintList-RecentlyReturnedPrintListContainer","39":"app-components-events-EventsSearchPage-EventsSearchPageContainer","40":"app-components-locations-LocationsPage-LocationsPageContainer","41":"app-components-search-Search-SearchContainer","42":"app-components-search-SearchPrintList-SearchPrintListContainer","43":"app-components-shared-AvailabilityDetailOverlay-AvailabilityDetailOverlayContainer","44":"app-components-shelves-Shelf-ShelfContainer","45":"app-components-shelves-ShelfPrintList-ShelfPrintListContainer","46":"app-components-widgets-WidgetsPage-WidgetsPageContainer"}[chunkId]||chunkId) + "-" + {"0":"b2388228eb28548eb68f","1":"022f24ffff29f6090128","2":"0b1e805c6ad5c640ca47","3":"7c5c7bbff09923170da3","4":"7fa2daffae44f9feb161","5":"aa90f1306d7b4d49dc79","6":"8c1ffd448b38e8bd03df","7":"5abd0573b49b916daeac","8":"e1dd03d6568a3bd2b1bf","9":"e123c16b955bfe2ec20d","10":"e91de5d19cc0d5b39a59","11":"bf3936d599ec4b053fd0","12":"87d9d9ac729ef3e4f305","13":"d52dd068f5641de16f5b","14":"04c6b9109849eda42ec2","15":"a3c2db8064657f927638","16":"361d7a0e8e78314923c7","17":"b446914621651850ae2c","18":"4ff8c2f38f34e9e23dc8","19":"abde326742b86df4b12b","20":"79c88f0a29c00853272e","21":"fe945202215575e4ebc5","22":"2f7c2158f9b9fb96c4ce","23":"c55fea9a2c32f5ed8973","24":"e0bd4c022e6c5c14e6e5","25":"cb55884c1e83827f528f","26":"32af9b2e18d12da5484c","27":"f49a68e1dc257c7b329f","28":"8b9878d13415a5d61d7f","29":"e7101019b6b5a20de126","30":"a035b303cc7abf366a2e","31":"f28453775e0f3dbc0213","32":"86cdd6cff56c398eca74","33":"f0f29e4f99a2335d001e","34":"2905e96c848178f347fa","35":"82a22c53dac093a991d8","36":"b52926f02e586ef3cbc1","37":"f22ecb238afda3f5a20f","38":"38966462e9701977fedb","39":"7fa3280d9de2f51c7a04","40":"3dacd22c814a3ed5b178","41":"dfa9b89360b8fc104bea","42":"f15b45694fc9dab89613","43":"ed7c7f489f53350098b5","44":"da381c4568b866798067","45":"8646b9d1070883960f89","46":"821166f8bf6563c75f74","48":"69d6dc2479e449e8e549","49":"7058791ed60f20f6ce4b","50":"39afbd332725c1303131","51":"d0f10ea72fe2e648fd3b","52":"0dcd0936b1087b34ed2c","53":"871f41572a794ee21939","54":"780fd906b92c05c7eea9"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1,"1":1,"2":1,"3":1,"4":1,"5":1,"6":1,"7":1,"8":1,"9":1,"10":1,"11":1,"12":1,"13":1,"14":1,"15":1,"16":1,"17":1,"18":1,"19":1,"20":1,"21":1,"22":1,"23":1,"24":1,"25":1,"26":1,"27":1,"28":1,"29":1,"30":1,"31":1,"32":1,"33":1,"34":1,"35":1,"36":1,"37":1,"38":1,"39":1,"40":1,"41":1,"42":1,"43":1,"44":1,"45":1,"46":1,"48":1,"49":1,"50":1,"51":1,"52":1,"53":1,"54":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "app." + ({"7":"DeprecatedStyles","13":"EnhancedStyles","14":"app-components-Workflow-WorkflowContainer","15":"app-components-bibs-BibPage-BibPageContainer","16":"app-components-bibs-subpages-AllCommentsPage-AllCommentsPageContainer","17":"app-components-bibs-subpages-AllContentNoticesPage-AllContentNoticesPageContainer","18":"app-components-bibs-subpages-AllListsPage-AllListsPageContainer","19":"app-components-bibs-subpages-AllQuotationsPage-AllQuotationsPageContainer","20":"app-components-bibs-subpages-AllRecommendationsPage-AllRecommendationsPageContainer","21":"app-components-bibs-subpages-AllReviewsPage-AllReviewsPageContainer","22":"app-components-bibs-subpages-AllSummariesPage-AllSummariesPageContainer","23":"app-components-bibs-subpages-AllVideosPage-AllVideosPageContainer","24":"app-components-bibs-subpages-CommentPage-CommentPageContainer","25":"app-components-bibs-subpages-MarcPage-MarcPageContainer","26":"app-components-bibs-subpages-QuotationPage-QuotationPageContainer","27":"app-components-bibs-subpages-SummaryPage-SummaryPageContainer","28":"app-components-bibs-subpages-VideoPage-VideoPageContainer","29":"app-components-borrowing-accountmessages-AccountMessages-AccountMessagesContainer","30":"app-components-borrowing-checkouts-CheckedOut-CheckedOutContainer","31":"app-components-borrowing-checkouts-CheckedOutPrintList-CheckedOutPrintListContainer","32":"app-components-borrowing-fines-Fines-FinesContainer","33":"app-components-borrowing-holds-Holds-HoldsContainer","34":"app-components-borrowing-holds-HoldsPrintList-HoldsPrintListContainer","35":"app-components-borrowing-interlibraryLoans-InterlibraryLoans-InterlibraryLoansContainer","36":"app-components-borrowing-interlibraryLoans-InterlibraryLoansPrintList-InterlibraryLoansPrintListContainer","37":"app-components-borrowing-recentlyreturned-RecentlyReturned-RecentlyReturnedContainer","38":"app-components-borrowing-recentlyreturned-RecentlyReturnedPrintList-RecentlyReturnedPrintListContainer","39":"app-components-events-EventsSearchPage-EventsSearchPageContainer","40":"app-components-locations-LocationsPage-LocationsPageContainer","41":"app-components-search-Search-SearchContainer","42":"app-components-search-SearchPrintList-SearchPrintListContainer","43":"app-components-shared-AvailabilityDetailOverlay-AvailabilityDetailOverlayContainer","44":"app-components-shelves-Shelf-ShelfContainer","45":"app-components-shelves-ShelfPrintList-ShelfPrintListContainer","46":"app-components-widgets-WidgetsPage-WidgetsPageContainer"}[chunkId]||chunkId) + "-" + {"0":"b2388228eb28548eb68f","1":"022f24ffff29f6090128","2":"0b1e805c6ad5c640ca47","3":"7c5c7bbff09923170da3","4":"7fa2daffae44f9feb161","5":"aa90f1306d7b4d49dc79","6":"8c1ffd448b38e8bd03df","7":"5abd0573b49b916daeac","8":"e1dd03d6568a3bd2b1bf","9":"e123c16b955bfe2ec20d","10":"e91de5d19cc0d5b39a59","11":"bf3936d599ec4b053fd0","12":"87d9d9ac729ef3e4f305","13":"d52dd068f5641de16f5b","14":"04c6b9109849eda42ec2","15":"a3c2db8064657f927638","16":"361d7a0e8e78314923c7","17":"b446914621651850ae2c","18":"4ff8c2f38f34e9e23dc8","19":"abde326742b86df4b12b","20":"79c88f0a29c00853272e","21":"fe945202215575e4ebc5","22":"2f7c2158f9b9fb96c4ce","23":"c55fea9a2c32f5ed8973","24":"e0bd4c022e6c5c14e6e5","25":"cb55884c1e83827f528f","26":"32af9b2e18d12da5484c","27":"f49a68e1dc257c7b329f","28":"8b9878d13415a5d61d7f","29":"e7101019b6b5a20de126","30":"a035b303cc7abf366a2e","31":"f28453775e0f3dbc0213","32":"86cdd6cff56c398eca74","33":"f0f29e4f99a2335d001e","34":"2905e96c848178f347fa","35":"82a22c53dac093a991d8","36":"b52926f02e586ef3cbc1","37":"f22ecb238afda3f5a20f","38":"38966462e9701977fedb","39":"7fa3280d9de2f51c7a04","40":"3dacd22c814a3ed5b178","41":"dfa9b89360b8fc104bea","42":"f15b45694fc9dab89613","43":"ed7c7f489f53350098b5","44":"da381c4568b866798067","45":"8646b9d1070883960f89","46":"821166f8bf6563c75f74","48":"69d6dc2479e449e8e549","49":"7058791ed60f20f6ce4b","50":"39afbd332725c1303131","51":"d0f10ea72fe2e648fd3b","52":"0dcd0936b1087b34ed2c","53":"871f41572a794ee21939","54":"780fd906b92c05c7eea9"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");

 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				var onLinkComplete = function (event) {
 					// avoid mem leaks.
 					linkTag.onerror = linkTag.onload = null;
 					if (event.type === 'load') {
 						resolve();
 					} else {
 						var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 						var realHref = event && event.target && event.target.href || fullhref;
 						var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
 						err.code = "CSS_CHUNK_LOAD_FAILED";
 						err.type = errorType;
 						err.request = realHref;
 						delete installedCssChunks[chunkId]
 						linkTag.parentNode.removeChild(linkTag)
 						reject(err);
 					}
 				};
 				linkTag.onerror = linkTag.onload = onLinkComplete;
 				linkTag.href = fullhref;

 				document.head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://cdn-nerf.bibliocommons.com/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["__LOADABLE_LOADED_CHUNKS__"] = window["__LOADABLE_LOADED_CHUNKS__"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 2328);
